import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { RouterModule } from "@angular/router";
import { Invitation, InvitationStatusEnum } from "@models/invitation";
import { InvitationStatusEnumPipe } from "@shared/pipes/invitation-status-enum.pipe";
import { environment } from "../../../../../../environments/environment";
import { ButtonComponent } from "../../../../../../shared/components/button/button.component";

@Component({
    selector: "app-event-invitation-card",
    imports: [
        CommonModule,
        ButtonComponent,
        InvitationStatusEnumPipe,
        RouterModule,
    ],
    templateUrl: "./event-invitation-card.component.html",
    styleUrl: "./event-invitation-card.component.scss"
})
export class EventInvitationCardComponent {
  @Input({ required: true }) invitation!: Invitation;
  @Input() isLoading = false;

  @Output()
  declineClick = new EventEmitter<number>();

  @Output()
  acceptClick = new EventEmitter<number>();

  invitationStatusEnum = InvitationStatusEnum;

  handleAcceptClick() {
    this.acceptClick.emit(this.invitation.id);
  }

  handleDeclineClick() {
    this.declineClick.emit(this.invitation.id);
  }

  loadEventImage(event_thumb: string) {
    return `${environment.BLOB_URL}/${event_thumb}`;
  }
}
